import React from "react"
import { useSelector } from "react-redux"
import {
  getIsLoading,
  getGroupedTasks,
  visibleColumns as visibleColumnsSelector,
  isLoadingUnassignedTasks,
  paginationTaskLoadedCount,
  paginationTaskTotalCount,
} from "reduxSlices/taskTableSlice"
import LoadingIndicator from "shared/LoadingIndicator"
import PaginationLoadingStatus from "shared/PaginationLoadingStatus"
import LoadUnassignedTasks from "./LoadUnassignedTasks"
import TaskGrouping from "./TaskGrouping"

const NO_DATA_TEXT = "There are no tasks for you right now."

const TaskGroupingList = () => {
  const loading = useSelector(getIsLoading)
  const loadingUnassignedTasks = useSelector(isLoadingUnassignedTasks)
  const visibleColumns = useSelector(visibleColumnsSelector)
  const taskGroups = useSelector(getGroupedTasks)
  const loadedCount = useSelector(paginationTaskLoadedCount)
  const totalCount = useSelector(paginationTaskTotalCount)

  if (loading) {
    return (
      <div className="flex flex-col items-center mt-16">
        <LoadingIndicator textValue="Loading tasks ..." />
        {
          !!loadedCount && !!totalCount && (
            <PaginationLoadingStatus loadedCount={loadedCount} totalCount={totalCount} />
          )
        }
      </div>
    )
  }

  const hasTasks = Object.values(taskGroups).some((group) => group.length !== 0)

  return (
    <div className="flex flex-col items-center gap-12">
      <div className="flex flex-col gap-16 w-full">
        {
          hasTasks
            ? (
              Object.entries(taskGroups).map(([groupName, tableData]) => (
                <TaskGrouping
                  key={groupName}
                  columns={visibleColumns}
                  groupName={groupName}
                  tableData={tableData}
                />
              ))
            )
            : (
              <div className="text-center">{ NO_DATA_TEXT }</div>
            )
        }
      </div>
      {
        loadingUnassignedTasks
          ? (
            <div className="flex flex-col items-center">
              <LoadingIndicator textValue="Loading unassigned tasks ..." />
            </div>
          )
          : (
            <LoadUnassignedTasks />
          )
      }
    </div>
  )
}

export default TaskGroupingList
